import { useMemo } from 'react'
import { useSkills } from '@renderer/chat/hooks/useSkills'
import { useSkillIcon } from '@renderer/components/skill-icon'

interface OriginSkillIconProps {
  skillName: string
  size?: number
}

/**
 * The badge icon for a report card: the originating skill's configured icon,
 * resolved by name from the user's skill list. A name with no matching skill
 * (renamed, deleted, or still loading) renders the default skill icon so the
 * card keeps its skill attribution instead of falling back to the app glyph.
 */
export function OriginSkillIcon({ skillName, size = 14 }: OriginSkillIconProps) {
  const { data: skills } = useSkills()
  const skill = useMemo(() => skills?.find((s) => s.name === skillName), [skills, skillName])
  const { Icon, color } = useSkillIcon(skill ?? { metadata: null })
  return <Icon size={size} style={{ color }} />
}
